import * as datastore from '@/datastore'

export interface Brand extends datastore.Reference {
	name: string
}

export const defaultBrand: Readonly<Brand> = {
	$id: '',
	name: '',
}
